import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../data.service';
import { GeneralService } from '../../../../general.service';
import { TranslateService } from '@ngx-translate/core';
import { CKEditor4 } from 'ckeditor4-angular';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { Console } from 'console';
import { WordcountService } from '../../../../wordcount.service';

declare var decimalInput: any;

@Component({
  selector: 'app-upload',
  templateUrl: './upload.html',
  styleUrls: ['./upload.scss']
})

export class UploadQs implements OnInit {

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public jsonFile: any;
  public filename: any;
  public uploadedfilename: any = "";
  public previewSrc: any = "";
  public previewSrcExtension = "";
  public attachment = false;
  public uploadInProgress = false;
  public uploadComplete = false;
  public attachmentExt = "";
  public questionId = 0;
  public chunksLeft = 0;
  public currentChunkIndex = 0;
  public chunks = [];
  public chunkUrl = "";

  private loadAnswersSubscription: Subscription;

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService,
    public sanitizer: DomSanitizer,
    private http: HttpClient,
    public wordCount: WordcountService
  ) {
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if (exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== "") {
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else {
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }
    
    this.loadAnswersSubscription = this.dataSvc.getLoadUploadAnswersEvent().subscribe(() => {
      this.loadAnswers();
    });
  }
  
  resetVariables(){
    
    this.previewSrc = "";
    this.previewSrcExtension = "";
    this.attachment = false;
    this.attachmentExt = "";
    this.uploadComplete = false;
    this.uploadInProgress = false;
  }
  ngOnInit(): void {
    this.loadAnswers();
  }

  loadAnswers() {
    this.resetVariables();
    if (this.dataSvc.currentQuestion.Question.QuestionType !== 1032) return;

    (<HTMLInputElement>document.getElementById('fuUploadQ')).value = "";

    var url = this.dataSvc.currentQuestion.Result.Selection;
    if(url !== "" && url !== null && url !== undefined){
      this.attachment = true;
      this.previewSrc = url;

      var fileurlstr = localStorage.getItem("Upload_" + this.dataSvc.currentExam.Session.SessionId + "_" + this.dataSvc.currentQuestion.Question.Question.QuestionID);
      if(fileurlstr !== null && fileurlstr !== undefined && fileurlstr !== "")
        this.uploadedfilename = fileurlstr;

      let fileExtension: string = this.getFileExtensionFromName(url);
      this.previewSrcExtension = "./assets/ext/" + this.getPreviewExtension(fileExtension) + ".png";
      this.attachmentExt = fileExtension;
      document.querySelector("#previewAttachment").setAttribute('href', this.previewSrc);
      document.querySelector("#previewImg").setAttribute('src', this.previewSrcExtension);
    }
    else{
      this.attachment = false;
      this.previewSrc = "";
      this.previewSrcExtension = "";
      document.querySelector("#previewAttachment").setAttribute('href', this.previewSrc);
      document.querySelector("#previewImg").setAttribute('src', this.previewSrcExtension);
    }

    clearInterval();
    
    if (this.attachment)
        setTimeout(() => this.updatePreviewSrc(), 200);
    
  }

  //LOAD FILE FROM DEVICE AND ATTEMPT TO READ JSON AND FILENAME
  loadFileFromDevice(event) {
    if(this.dataSvc.previewMode)
      return;

    
    const file = event.target.files[0];
    if(file !== null && file !== undefined){
      if(file.size > 4194304) {
        alert("Sorry file could not be uploaded. The maximum file size is 4mb");
        return;
      }
      let fileName = file.name;
      let ext = fileName.split('.').pop().toLowerCase();

      if (['pdf', 'jpg', 'jpeg', 'png', 'mp4'].indexOf(ext) < 0) {
        event.target.value = '';
        alert('Wrong file type selected!');
        return;
      }
      this.filename = fileName;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
          this.jsonFile = reader.result.toString();
          localStorage.setItem("Upload_" + this.dataSvc.currentExam.Session.SessionId + "_" + this.dataSvc.currentQuestion.Question.Question.QuestionID, this.filename);
          this.uploadedfilename = this.filename;
          this.attachmentExt = this.filename.split('.').pop().toLowerCase()

          this.uploadAttachment();
      }
      reader.onerror = (error) => {
      //handle errors
      alert("Sorry file could not be uploaded. Please try again");
      return;
      };    
    }    
  }
  
  uploadAttachment() {
    if(this.dataSvc.previewMode)
      return;
      
    if (this.jsonFile !== null && this.jsonFile !== undefined && this.jsonFile !== "") {   
      this.uploadComplete = false; 
      this.uploadInProgress = true;

      if(this.jsonFile.indexOf("base64,"))
        this.jsonFile = this.jsonFile.substr(this.jsonFile.indexOf("base64,") + 7);

      var chunkSize = 1000000;
      var jsonLength = this.jsonFile.length;
      var numberOfChunks = Math.ceil(jsonLength / chunkSize);
      this.chunks = [];

      for (var i = 0; i < numberOfChunks; i++) {
        var chunk = this.jsonFile.substr(i*chunkSize, chunkSize);
        this.chunks.push(chunk);
      }

      this.chunksLeft = this.chunks.length;
      this.currentChunkIndex = 0;
      this.chunkUrl = this.dataSvc.environment 
      + "/Media/UploadAttachmentv2/" + this.dataSvc.currentExam.Session.SessionId
      + "/" + this.dataSvc.currentQuestion.Question.Question.QuestionID + "/" + this.attachmentExt + "/" + this.chunks.length ;

      this.uploadAttachmentChunk();  
    }
    else{
      this.uploadFailed();
    }
  }

  uploadAttachmentChunk() {
    if (this.chunksLeft == 0) {
      this.updatePreviewSrc();
      this.attachment = true;
      this.uploadInProgress = false;
      this.uploadComplete = true;
    } else {
      var apiUrl = this.chunkUrl + "/" + this.currentChunkIndex;
      this.http.post(apiUrl, {data: this.chunks[this.currentChunkIndex] }).subscribe((res: any) => { 
        //console.log(res);     
        if(res.status == "Success") {
          this.chunksLeft += -1;
          this.currentChunkIndex += 1;
          this.uploadAttachmentChunk();
        }
        else if(res.status != "Awaiting") {
          this.uploadFailed();
          alert("Sorry file could not be uploaded. " + res.message);
        }
      }); 
    }     
  }

  uploadFailed(){
    this.attachment = false;
    this.uploadInProgress = false;
    this.uploadComplete = false;
      this.previewSrc = "";
      document.querySelector("#previewAttachment").setAttribute('href', this.previewSrc);
      document.querySelector("#previewImg").setAttribute('src', "");
  }

  updatePreviewSrc() {
    this.previewSrc = this.dataSvc.blobUrl + "/" + this.dataSvc.assessBlobContainer + "/SessionFiles/Exam/" + this.dataSvc.currentExam.Session.SessionId
      + "/" + this.dataSvc.currentQuestion.Question.Question.QuestionID + "/attachment." + this.attachmentExt;
    this.previewSrcExtension = "./assets/ext/" + this.getPreviewExtension(this.attachmentExt) + ".png";

    document.querySelector("#previewAttachment").setAttribute('href', this.previewSrc);
    document.querySelector("#previewImg").setAttribute('src', this.previewSrcExtension);
    this.dataSvc.currentQuestion.Result.Selection = this.previewSrc;
  }

  getPreviewExtension(fileExtension) {
    var extension = "";
    switch (fileExtension) {
      case "doc":
      case "docx":
        extension = "doc";
        break;
      case "xls":
      case "xlsx":
        extension = "xls";
        break;
      case "pdf":
        extension = "pdf";
        break;
      case "jpg":
      case "jpeg":
        extension = "jpg";
        break;
      case "png":
        extension = "png";
        break;
      case "mp3":
        extension = "mp3";
        break;
      case "mp4":
        extension = "mp4";
        break;
      case "gif":
        extension = "gif";
        break;
      case "zip":
        extension = "zip";
        break;
      case "txt":
        extension = "txt";
        break;
      default:
        extension = "file";
        break;
    }

    return extension;
  }

  getFileExtensionFromName(filename) {
    return filename.split('.').pop();
  }

  openAttachment() {
    window.open(this.previewSrc);
  }

}
